import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-319aadf2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "tree-item"
};
const _hoisted_2 = {
  key: 0,
  class: "tree-item__content"
};
const _hoisted_3 = {
  class: "tree-item__content__text"
};
const _hoisted_4 = {
  key: 1,
  class: "tree-item__loadMore"
};
import Icon from '@teams/common/components/icon';
export default /*#__PURE__*/_defineComponent({
  __name: 'treeItem',
  props: {
    option: null
  },

  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!props.option.isLoadMore ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_unref(Icon), {
        name: "folder",
        size: 16
      }), _createElementVNode("div", _hoisted_3, _toDisplayString(props.option.label), 1)])) : _createCommentVNode("", true), props.option.isLoadMore ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 加载更多 ")) : _createCommentVNode("", true)]);
    };
  }

});